import { TranslationStringType } from "@localization/LocalizationContext";
import { SegmentedControlOption } from "@common/components/segmentedControl/SegmentedControl";
import { createViewQuery } from "@common/components/viewSwitcher/viewSwitcherQuery";

// The view switcher identifies views by numeric value; the query string persists the human-readable
// view name (?view=governance|operational|mitigation|history) while the switcher works with these values.
export enum RiskAreaTab {
    Governance = 0,
    Operational = 1,
    Mitigation = 2,
    History = 3,
}

const queryByTab: Record<RiskAreaTab, string> = {
    [RiskAreaTab.Governance]: "governance",
    [RiskAreaTab.Operational]: "operational",
    [RiskAreaTab.Mitigation]: "mitigation",
    [RiskAreaTab.History]: "history",
};

const viewQuery = createViewQuery(queryByTab, RiskAreaTab.Operational);

export function riskAreaTabToQuery(tab: RiskAreaTab): string {
    return viewQuery.toQuery(tab);
}

export function riskAreaTabFromQuery(value: string | null): RiskAreaTab {
    return viewQuery.fromQuery(value);
}

export function buildRiskAreaViews(translateString: TranslationStringType): Array<SegmentedControlOption<RiskAreaTab>> {
    return [
        { label: translateString("riskAreaTabGovernance"), value: RiskAreaTab.Governance },
        { label: translateString("riskAreaTabOperational"), value: RiskAreaTab.Operational },
        { label: translateString("riskAreaTabMitigation"), value: RiskAreaTab.Mitigation },
        { label: translateString("riskAreaTabHistory"), value: RiskAreaTab.History },
    ];
}
